module.exports = __webpack_public_path__ + "static/img/ktcu-cs-competition-proposal.b643035.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ktcu-cs-competition-proposal.jpg
// module id = KBOc
// module chunks = 0